const confirmType = {
  confirm_ok: 1,
  confirm: 2,
  download: 3,
  only_close: 4,
};

const icons = [
    {
        id:1,
        name: "読売ジャイアンツ",
        icon: "/img/team/Giants.png"
    }
    , {
        id:3,
        name: '横浜ＤｅＮＡベイスターズ',
        icon: '/img/team/DeNA.png'
    }
    , {
        id:5,
        name: '阪神タイガース',
        icon: '/img/team/Tigers.png'
    }
    , {
        id:6,
        name: '広島東洋カープ',
        icon: '/img/team/Carp.png'
    }
    , {
        id:4,
        name: '中日ドラゴンズ',
        icon: '/img/team/Dragons.png'
    }
    , {
        id:2,
        name: '東京ヤクルトスワローズ',
        icon: '/img/team/Swallows.png'
    }
    , {
        id:7,
        name: '埼玉西武ライオンズ',
        icon: '/img/team/Lions.png'
    }
    , {
        id:12,
        name: '福岡ソフトバンクホークス',
        icon: '/img/team/Hawks.png'
    }
    , {
        id:376,
        name: '東北楽天ゴールデンイーグルス',
        icon: '/img/team/Eagles.png'
    }
    , {
        id:9,
        name: '千葉ロッテマリーンズ',
        icon: '/img/team/Marines.png'
    }
    , {
        id:8,
        name: '北海道日本ハムファイターズ',
        icon: '/img/team/Fighters.png'
    }
    , {
        id:11,
        name: 'オリックス・バファローズ',
        icon: '/img/team/Bufalloes.png'
    }
    , {
        id:15,
        name: 'オールパリーグ',
        icon: '/img/team/Pacific.png'
    }
    , {
        id:16,
        name: 'オールセリーグ',
        icon: '/img/team/Central.png'
    }
];

const detectIconById = (team_id) => {
    const findData = icons.find(o => team_id &&  parseInt(team_id) === o.id) || {icon: null};
    return findData.icon;
};

const getCookie = (cookie) => {
  return document.cookie.split(';').reduce((prev, c) => {
    var arr = c.split('=');
    return (arr[0].trim() === cookie) ? arr[1] : prev;
  }, undefined);
}

const month = [
    {
        id: '01',
        month: '1月',
        active: false
    },
  {
      id : '02',
      month: '2月',
      active: false
  },
  {
      id : '03',
      month: '3月',
      active: false
  },
  {
      id : '04',
      month: '4月',
      active: false
  },
  {
      id : '05',
      month: '5月',
      active: false
  },
  {
      id : '06',
      month: '6月',
      active: false
  },
  {
      id : '07',
      month: '7月',
      active: false
  },
  {
      id : '08',
      month: '8月',
      active: false
  },
  {
      id : '09',
      month: '9月',
      active: false
  },
  {
      id : '10',
      month: '10月',
      active: false
  },
  {
      id : '11',
      month: '11月',
      active: false
  },
  {
      id : '12',
      month: '12月',
      active: false
  }
]

const loginimgpc = [
    '/img/loginpc/login_photo.png',
    '/img/loginpc/login_photo_02.png',
    '/img/loginpc/login_photo_03.png',
    '/img/loginpc/login_photo_04.png',
    '/img/loginpc/login_photo_05.png',
    '/img/loginpc/login_photo_06.png',
    '/img/loginpc/login_photo_07.png',
    '/img/loginpc/login_photo_08.png',
    '/img/loginpc/login_photo_09.png',
    '/img/loginpc/login_photo_10.png'
]
const detectloginimgpcById = (id) => {
    return loginimgpc[parseInt(id)] ?? null;
};

const loginimgsp = [
    '/img/loginsp/login_photo_sp.png',
    '/img/loginsp/login_photo_sp_02.png',
    '/img/loginsp/login_photo_sp_03.png',
    '/img/loginsp/login_photo_sp_04.png',
    '/img/loginsp/login_photo_sp_05.png',
    '/img/loginsp/login_photo_sp_06.png',
    '/img/loginsp/login_photo_sp_07.png',
    '/img/loginsp/login_photo_sp_08.png',
    '/img/loginsp/login_photo_sp_09.png',
    '/img/loginsp/login_photo_sp_10.png'
]
const detectloginimgspById = (id) => {
    return loginimgsp[parseInt(id)] ?? null;
};

export { confirmType, getCookie, month, detectIconById, detectloginimgpcById, detectloginimgspById };
